'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var ProductPrice = require('./ProductPrice.js');
var ui = require('../../../paragraph/ui.js');
var ui$1 = require('../../../image/ui.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductItem = (_a) => {
  var _b = _a, {
    product,
    isEditorMode
  } = _b, rest = __objRest(_b, [
    "product",
    "isEditorMode"
  ]);
  const renderProduct = /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsxs(ProductCardContent, {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(ProductVisualWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: { position: "relative", paddingBottom: "100%" },
            children: /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
              commonStyle: {
                objectFit: "contain",
                height: "100%",
                width: "100%"
              },
              src: product.imageUrl,
              width: 300,
              showPlaceholder: false
            })
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductNameWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(ProductName, {
            text: product.name
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductSaleInfo, {
          children: /* @__PURE__ */ jsxRuntime.jsx(ProductPrice.ProductPrice, {
            latestPrice: product.latestPrice,
            supplierRetailPrice: product.supplierRetailPrice,
            textColor: rest.priceColor
          })
        })
      ]
    })
  });
  if (product.url && !isEditorMode)
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx("a", {
        href: product.url,
        target: "_blank",
        children: renderProduct
      })
    });
  return renderProduct;
};
const Wrapper = styled__default["default"].div`
  position: relative;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
`;
const ProductCardContent = styled__default["default"].div`
  position: relative;
  flex: 1 0 auto;
  margin-bottom: 8px;
`;
const ProductVisualWrapper = styled__default["default"].div`
  position: relative;
  margin-bottom: 4px;
`;
const ProductNameWrapper = styled__default["default"].div`
  height: 2rem;
`;
const ProductName = styled__default["default"](ui.Paragraph)`
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #434657;
  font-weight: 400;
`;
const ProductSaleInfo = styled__default["default"].div`
  position: relative;
  margin-top: 4px;
`;
const StyledImage = styled__default["default"](ui$1.Image)`
  display: inline-block;
  overflow: hidden;
  position: absolute;
  height: 100%;
  inset: 0;
`;

exports.ProductItem = ProductItem;
